import React, {useContext} from 'react';
import moment from 'moment';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import {useTranslation} from 'react-i18next';
import AfficheImage from 'components/Shared/AfficheImage';
import Context from 'utils/Context';
// import {useTimezone} from 'hooks';

import './CartoucheVod.scss';

const translatorGuessedTz = g => {
  switch (g) {
    case 'Europe/Paris':
      return 'fr';
    default:
      return 'en-gb';
  }
};

const CartoucheVod = ({vod}) => {
  const {t} = useTranslation();
  const {appState, goTo} = useContext(Context);

  const tzGuessed = moment.tz.guess();
  const rentDate = moment(vod.start)
    .locale(translatorGuessedTz(tzGuessed))
    .format('DD MMMM YYYY HH:mm');
  const endRent = moment(vod.end)
    .locale(translatorGuessedTz(tzGuessed))
    .format('DD MMMM YYYY HH:mm');

  return (
    <div className="seance-cartouche shadow">
      <div className="seance-cartouche-content">
        <Typography variant={appState.screenSize === 'xs' ? 'h6' : 'h4'} noWrap>
          {vod.film.name}
        </Typography>
      </div>
      <div className="spacer" />
      <Grid className="main-container" container spacing={0}>
        <Grid item xs={3}>
          <AfficheImage affiche={vod.film.affiche} />
        </Grid>
        <Grid item xs={9} className="content-container">
          <div>
            <Typography variant={'h6'}>
              {`${t('Cinéma')} : `}
              <Typography className="occurency">{vod.cinema.name}</Typography>
            </Typography>
            <Typography variant={'h6'}>
              {`${t('Loué le')} : `}
              <Typography className="occurency">{rentDate}</Typography>
            </Typography>

            <Typography variant={'h6'}>
              {`${t("Disponible jusqu'au")} : `}
              <Typography className="occurency">{endRent}</Typography>
            </Typography>
          </div>
          <Button
            className="access-movie"
            color="primary"
            variant="contained"
            onClick={() => goTo(`/cinema/${vod.cinema?.id}/${vod.film?.id}`)}
          >
            {t('acceder-au-film')}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default CartoucheVod;
